<button
    attr.id="{{ identity }}"
    class="skip-link"
    (activate)="goToContent(skipLocation)">
    {{ title }}
</button>
